<mat-tree
  [dataSource]="dataSource"
  [treeControl]="treeControl"
  [trackBy]="trackBy"
  class="distribute-tree mt-3"
>
  <mat-tree-node
    *matTreeNodeDef="let node"
    matTreeNodeToggle
    [class.active]="selectedNode?.id === node.id"
    matTreeNodePadding
    matTreeNodePaddingIndent="20"
  >
    <ng-container
      [ngTemplateOutlet]="treeNode"
      [ngTemplateOutletContext]="{ $implicit: node, class: 'px-3 margin-node' }"
    ></ng-container>
  </mat-tree-node>

  <mat-nested-tree-node
    *matTreeNodeDef="let node; when: hasChild"
    matTreeNodePadding
    matTreeNodePaddingIndent="20"
    [class.node-visible]="treeControl.isExpanded(node)"
  >
    <div class="mat-tree-node" [class.active]="selectedNode?.id === node.id">
      <button
        mat-icon-button
        matTreeNodeToggle
        [attr.aria-label]="'Toggle ' + node.criterionEnglishName"
      >
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>
      <ng-container
        [ngTemplateOutlet]="treeNode"
        [ngTemplateOutletContext]="{
          $implicit: node,
          class: '',
          span: treeControl.isExpanded(node)
        }"
      ></ng-container>
    </div>

    <div [class.tree-invisible]="!treeControl.isExpanded(node)" role="group">
      <ng-container matTreeNodeOutlet></ng-container>
    </div>
  </mat-nested-tree-node>
</mat-tree>

<ng-template #treeNode let-node let-class="class" let-span="span">
  <div
    (click)="rowClicked(node)"
    class="distribute-tree__node"
    [class]="class"
    role="button"
  >
    <span [class.font-bold]="span" class="clamp py-2">
      {{ node?.criterionKey && node?.criterionKey + ' - ' }}
      {{ lang === 'ar' ? node.criterionArabicName : node.criterionEnglishName }}</span
    >
    <app-member-length-icon
      *ngIf="node?.visitMembers?.length"
      [members]="node?.visitMembers"
    ></app-member-length-icon>
  </div>
</ng-template>
